import { render, staticRenderFns } from "./PartnerDetails.vue?vue&type=template&id=545d348a&"
import script from "./PartnerDetails.vue?vue&type=script&lang=js&"
export * from "./PartnerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545d348a')) {
      api.createRecord('545d348a', component.options)
    } else {
      api.reload('545d348a', component.options)
    }
    module.hot.accept("./PartnerDetails.vue?vue&type=template&id=545d348a&", function () {
      api.rerender('545d348a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/integrations/PartnerDetails.vue"
export default component.exports